import React from "react";
// Chakra imports
import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import portfolio1 from "assets/img/portfolio/portfolio1.png";
import portfolio2 from "assets/img/portfolio/portfolio2.png";
import portfolio3 from "assets/img/portfolio/portfolio3.png";
import portfolio4 from "assets/img/portfolio/portfolio4.png";
import portfolio5 from "assets/img/portfolio/portfolio5.png";
import portfolio6 from "assets/img/portfolio/portfolio6.png";
import portfolio7 from "assets/img/portfolio/portfolio7.png";
import portfolio8 from "assets/img/portfolio/portfolio8.png";
import portfolio9 from "assets/img/portfolio/portfolio9.png";
import portfolio10 from "assets/img/portfolio/portfolio10.png";
import portfolio11 from "assets/img/portfolio/portfolio11.png";
import portfolio12 from "assets/img/portfolio/portfolio12.png";
import portfolio13 from "assets/img/portfolio/portfolio13.png";
import Slider from "components/slider";

// Assets

// Custom components
import InnerContent from "layouts/innerContent";
import { HSeparator } from "components/separator/Separator";

export default function Portfolio() {
  //   const duration1 = 4000;
  //   const duration2 = 5000;
  //   const duration3 = 4500;
  const duration1 = 4.5;
  const duration2 = 5;
  const duration3 = 4;
  const slides1 = [
    <Image
      src={portfolio1}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio2}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio3}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio4}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio5}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
  ];
  const slides2 = [
    <Image
      src={portfolio6}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio7}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio8}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio9}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
  ];
  const slides3 = [
    <Image
      src={portfolio10}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio11}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio12}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
    <Image
      src={portfolio13}
      w={{ base: "250px", md: "476px" }}
      h={{ base: "150px", md: "286px" }}
    />,
  ];
  const textColor = useColorModeValue("#09090B", "white");
  return (
    <Flex
      w="100%"
      direction={{ base: "column" }}
      pb={{ base: "90px", md: "100px", xl: "140px" }}
      overflow="hidden"
      position="relative"
    >
      <InnerContent w="100%" px={{ base: "20px", md: "40px", xl: "0px" }}>
        {/* Header */}
        <HSeparator bg="linear-gradient(270deg, rgba(226, 232, 240, 0.00) 0%, rgba(226, 232, 240, 0.65) 25.52%, #E2E8F0 52.6%, rgba(226, 232, 240, 0.65) 80.21%, rgba(226, 232, 240, 0.00) 100%)" />
        <Flex
          maxW="100%"
          direction="column"
          mx="auto"
          pt={{ base: "100px", md: "100px", xl: "160px" }}
          mb={{ base: "50px", md: "100px", lg: "100px" }}
          alignItems="center"
          justify={"center"}
          textAlign="center"
        >
          <Text
            as="h3"
            textAlign={{ base: "center", lg: "center" }}
            fontWeight="700"
            letterSpacing="2px"
            color={textColor}
            fontSize={{ base: "xs", md: "md" }}
            w="100%"
            mb="10px"
          >
            OUR WORK PORTFOLIO
          </Text>
          <Text
            as="h2"
            textAlign={{ base: "center" }}
            color={textColor}
            fontWeight="800"
            fontSize={{ base: "28px", md: "48px", lg: "48px", xl: "48px" }}
            lineHeight={{ base: "38px", md: "60px", lg: "60px", xl: "60px" }}
            w={{ base: "100%", md: "89%", lg: "90%", xl: "70%" }}
            mx="auto"
            mb="50px"
          >
            We’ve built a lot of great projects. Let’s make yours possible now.
          </Text>
          {/* ----------------------------------- */}
          <Slider mb="20px" slides={slides1} duration={duration1} />
          <Slider mb="20px" slides={slides2} duration={duration2} />
          <Slider slides={slides3} duration={duration3} />
          {/* ----------------------------------- */}
        </Flex>
      </InnerContent>
    </Flex>
  );
}
